import { DatabaseWrapper } from '../../../shared/databases/database.wrapper';
import { Database } from '../../../shared/databases/database';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { RepConnWrapper } from '../../repconn/repconn.wrapper';
import { ObjectWrapper } from 'src/app/shared/wrappers/object.wrapper';
import { Attribute } from 'src/app/shared/models/domain/attribute';

export class DruidWrapper extends DatabaseWrapper {
    constructor(database: Database) {
        super(database);

        this.dbTyp_Id = DatabaseEnum.druid.ID;
        this.name = DatabaseEnum.druid.NAME;
        this.code = DatabaseEnum.druid.CODE;
        this.equivalentTag = DatabaseEnum.druid.EQUIVALENT_TAG;
        this.dataObjectConnDatabaseNm = 'Database';
        this.isFileType = true;
        this.hideSchemaNmColumn = false;
        this.showDataDescription = false;
    }

    validateRepConn(repConnWrapper: RepConnWrapper): void {
        if (repConnWrapper.repConn.conn.host == "") {
            repConnWrapper.inValid_Cds.push('NO_HOST');
        }

        if (repConnWrapper.repConn.conn.port == "") {
            repConnWrapper.inValid_Cds.push('NO_PORT');
        }

        if (repConnWrapper.repConn.conn.secAuth != 'None') {
            if (repConnWrapper.repConn.conn_Usr.conn_Usr == "") {
                repConnWrapper.inValid_Cds.push('NO_CONN_USER');
            }
            if (repConnWrapper.repConn.conn_Usr.usrPasswd == "") {
                repConnWrapper.inValid_Cds.push('NO_PASSWORD');
            }
        }

        /*if( repConnWrapper.repConn.conn_Dbs.length != 0 ) {
            if( repConnWrapper.repConn.conn_Dbs[0].databaseNm == "" ) {
                repConnWrapper.inValid_Cds.push('NO_DATABASE_NM');
            }
        }*/

        if (repConnWrapper.repConn.conn.flagent_Id == -1) {
            repConnWrapper.inValid_Cds.push('ESM00202');
        }

        /*if( repConnWrapper.repConn.conn_Dbs.length < 1 ) {
            repConnWrapper.inValid_Cds.push('NO_DATABASE');
        }*/

    }

    getDerivedAttributeColumns(objectWrapper: ObjectWrapper, component: any, isMax: boolean = false, attributes: Array<Attribute> = new Array<Attribute>(), isHiveNative: boolean = false): Array<any> {
        return [
            this.attributeTabulator.getCheckBoxColumn(objectWrapper),
            this.attributeTabulator.getSrt_Order(),
            this.attributeTabulator.getAttr_Id(),
            this.attributeTabulator.getAttrNm(objectWrapper,component),
            this.attributeTabulator.getAttrDTyp_Id(objectWrapper),
            this.attributeTabulator.getAttrPrec(objectWrapper),
            this.attributeTabulator.getAttrScale(objectWrapper),
            this.attributeTabulator.getMaxFlag(objectWrapper, isMax),
            this.attributeTabulator.getDistKeyFlag(objectWrapper),
            this.attributeTabulator.getOrderBy(objectWrapper, component),
            this.attributeTabulator.getPartitionflag(objectWrapper, isHiveNative),
            this.attributeTabulator.getAttrExprVal(objectWrapper, component),
            this.attributeTabulator.getValid_Cd(objectWrapper, component),
        ]
    }

    getAttributeColumns(objectWrapper: ObjectWrapper,
        attributes: Array<Attribute> = new Array<Attribute>(), component: any = null,hideRowSelection:boolean=true): Array<any> {
        return [
            this.attributeTabulator.getCheckBoxColumn(objectWrapper,hideRowSelection),
            this.attributeTabulator.getSrt_Order(),
            this.attributeTabulator.getAttr_Id(),
            this.attributeTabulator.getAttrNm(objectWrapper,component),
            this.attributeTabulator.getAttrDTyp_Id(objectWrapper, attributes, component),
            this.attributeTabulator.getTimestampSpec(objectWrapper),
            this.attributeTabulator.getMetricsSpec(objectWrapper),
            this.attributeTabulator.getMetricsType(objectWrapper),

            /* this.attributeTabulator.getAttrPrec(objectWrapper),
             this.attributeTabulator.getAttrScale(objectWrapper),
             this.attributeTabulator.getNotNullFlag(),
             this.attributeTabulator.getAttrKeyTyp_Id(objectWrapper),
             this.attributeTabulator.getDistKeyFlag(objectWrapper),
             this.attributeTabulator.getOrderBy(objectWrapper),
             this.attributeTabulator.getDescription(objectWrapper),*/
        ]
    }

    // getRollupSelectAttributeColumns(objectWrapper: ObjectWrapper): Array<any> {
    //     return [
    //         this.attributeTabulator.getCheckBoxColumn(objectWrapper),
    //         this.lAttributeTabulator.getSrt_Order(),
    //         this.lAttributeTabulator.getLAttr_Id(),
    //         this.lAttributeTabulator.getLAttrNm(objectWrapper),
    //         this.lAttributeTabulator.getSelectColumn(objectWrapper),
    //         this.lAttributeTabulator.getAttrDTypNm(objectWrapper),
    //         this.lAttributeTabulator.getLAttrPrec(objectWrapper),
    //         this.lAttributeTabulator.getLAttrScale(objectWrapper),
    //         this.lAttributeTabulator.getLAttrType( objectWrapper ),
    //         this.lAttributeTabulator.getLAttrFunction( objectWrapper),
    //         this.lAttributeTabulator.getDistKeyFlag(objectWrapper),
    //         this.lAttributeTabulator.getOrgKeyFlag(objectWrapper),
    //         this.lAttributeTabulator.getPartFlag(objectWrapper),
    //         this.lAttributeTabulator.getOrderBy(objectWrapper)
    //     ]
    // }

    getLAttributeColumns(objectWrapper: ObjectWrapper, component): Array<any> {
        return [
            this.attributeTabulator.getCheckBoxColumn(objectWrapper),
            this.lAttributeTabulator.getSrt_Order(),
            this.lAttributeTabulator.getLAttr_Id(),
            this.lAttributeTabulator.getLAttrNm(objectWrapper),
            this.lAttributeTabulator.getSelectColumn(objectWrapper),
            this.lAttributeTabulator.getAttrDTypNm(objectWrapper),
            this.lAttributeTabulator.getLAttrPrec(objectWrapper),
            this.lAttributeTabulator.getLAttrScale(objectWrapper),
            this.lAttributeTabulator.getLAttrType(objectWrapper),
			this.lAttributeTabulator.getLAttrFunction(objectWrapper),
            this.lAttributeTabulator.getDistKeyFlag(objectWrapper, 'Partition'),
            this.lAttributeTabulator.getOrderBy(objectWrapper, component)
        ]
    }
}
